<template>
  <Modal
    @close="$emit('close')"
  >
    <div
      class="px-5 pt-16 lg:p-8"
      style="max-width: 520px"
    >
      <h2 class="text-ma-red-1 text-3xl font-bold">
        Wait!
      </h2>
      <div class="mt-5">
        <p class="text-lg text-b30 mb-6">
          You are about to delete all your data from Motion Array, along with any uploads and downloads.
        </p>
        <p class="text-lg text-b30 mb-3">
          Are you sure you want delete your account now?
        </p>

        <div class="flex flex-wrap items-center justify-center lg:justify-between pb-4">
          <div
            class="text-b30 underline mr-3 cursor-pointer action-cancel mb-3 lg:mb-0"
            @click="$emit('close')"
          >
            No, keep my account
          </div>
          <div class="mb-3 lg:mb-0">
            or
          </div>

          <button
            class="py-3 px-6 mx-3 al-btn al-btn--primary-dark font-bold text-primary-offwhite"
            :disabled="submitting"
            @click="deleteAccount"
          >
            Yes, delete my account
            <div
              v-if="submitting"
              class="flex items-center justify-center ml-4"
            >
              <div class="w-2 h-2 border-b-2 border-white rounded-full animate-spin" />
            </div>
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal';

export default {
  components: {
    Modal,
  },
  props: {
    deleteAccount: {
      type: Function,
      default: (() => {}),
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.action-cancel:hover {
  @apply text-primary-purple;
}
.al-btn:disabled {
  opacity: 0.7;
  cursor: auto;
}
</style>
